import React from 'react';
import { Button, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { generateColorFromId } from './utils';

const BasicRackDevice = ({
  deviceId,
  device,
  groupUNumbers,
  totalHeight,
  renderEquipmentName,
  onDeleteMapping,
  startU,
}) => (
  <div style={{ marginBottom: '8px' }}>
    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {groupUNumbers.map((uNumber) => (
          <div
            key={uNumber}
            style={{
              border: '2px solid #000',
              padding: '8px',
              backgroundColor: generateColorFromId(deviceId),
              fontWeight: 'bold',
              borderRadius: '4px',
              boxShadow: 'inset 0 1px 3px rgba(199, 31, 31, 0.1)',
              minWidth: '80px',
              minHeight: '60px',
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {uNumber}U
          </div>
        ))}
      </div>
      <div style={{ flex: 1, position: 'relative' }}>
        <div
          style={{
            border: '3px solid #000',
            padding: '12px',
            backgroundColor: generateColorFromId(deviceId),
            height: `${totalHeight}px`,
            borderRadius: '4px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            color: '#000',
            fontWeight: 'bold',
            paddingLeft: '16px',
            position: 'relative',
            boxSizing: 'border-box',
          }}
        >
          {device ? (
            <>
              <span style={{ fontWeight: 'bold' }}>
                <a
                  href={`/rackdevice/view/${device}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: '#000',
                    fontSize: '14px',
                    textDecoration: 'none',
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.textDecoration = 'underline';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.textDecoration = 'none';
                  }}
                >
                  {renderEquipmentName(device)}
                </a>
              </span>
              <Popconfirm
                title="Are you sure you want to remove this device mapping?"
                onConfirm={() => onDeleteMapping(startU)}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  type="text"
                  danger
                  icon={<DeleteOutlined />}
                  style={{
                    position: 'absolute',
                    right: '8px',
                    top: '8px',
                    padding: '4px 8px',
                  }}
                />
              </Popconfirm>
            </>
          ) : (
            <span>{renderEquipmentName(deviceId)}</span>
          )}
        </div>
      </div>
    </div>
    <div style={{ borderBottom: '2px solid #000', paddingBottom: '8px' }} />
  </div>
);

export default BasicRackDevice;
